import { InputHTMLAttributes, DetailedHTMLProps } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ITextInputHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  pattern?: string;
  error?: string;
  secondDiv?: string;
  placeholder?: string;
  onChange?: (e: any) => void;
}
const NumericInputField: React.FC<ITextInputHookForm> = ({
  className = "border border-gray-300 focus:ring-septenary focus:border-septenary col-span-2",
  secondDiv = "grid grid-cols-1 md:grid-cols-3",
  disabled = false,
  required = false,
  pattern = "/d",
  register,
  label,
  step,
  min,
  max,
  error,
  placeholder = "0",
  onChange,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`${secondDiv} w-full items-center`}>
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}:
          </label>
        )}
        <div className="col-span-2">
          <input
            className={`block w-full bg-white bg-clip-padding leading-normal outline-none
            px-1 py-1 text-xs sm:text-xs rounded-sm ${className} ${
              disabled && "opacity-50"
            } ${error ? "border-red-500 border-2" : ""}`}
            step={step}
            min={min}
            max={max}
            {...register}
            disabled={disabled}
            placeholder={placeholder}
            type="number"
            pattern={pattern}
            onChange={onChange}
            {...props}
          />
          {error ? (
            <p className="text-red-500 text-[11px] mt-1">{error}</p>
          ) : (
            <p className="text-xs text-gray-500 mt-1 italic">
              Note: Only availabe office number is 1-9999 or 30000 above.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default NumericInputField;
